
import Service from '@/service/cdn_config'

export const STATUS = {
    START: 'start',
    DOING: 'doing',
    DONE: 'done',
    SHARE: 'share'
}

export const getConfig = Service.getCheckCondition
